import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {
  readonly solid = input(false);
}
